import { useEffect } from 'react'

interface MetaTagsProps {
  title: string
  description?: string
}

export default function MetaTags({ title, description }: MetaTagsProps) {
  useEffect(() => {
    // Set document title
    document.title = title

    // Set meta description
    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]')
      if (!metaDescription) {
        metaDescription = document.createElement('meta')
        metaDescription.setAttribute('name', 'description')
        document.head.appendChild(metaDescription)
      }
      metaDescription.setAttribute('content', description)
    }

    // Set Open Graph tags
    const ogTags = [
      { property: 'og:title', content: title },
      { property: 'og:description', content: description || '' },
      { property: 'og:type', content: 'website' },
      { property: 'og:site_name', content: 'profile.work' },
    ]

    ogTags.forEach(({ property, content }) => {
      if (!content) return
      let metaTag = document.querySelector(`meta[property="${property}"]`)
      if (!metaTag) {
        metaTag = document.createElement('meta')
        metaTag.setAttribute('property', property)
        document.head.appendChild(metaTag)
      }
      metaTag.setAttribute('content', content)
    })

    // Set Twitter card tags
    const twitterTags = [
      { name: 'twitter:card', content: 'summary' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description || '' },
    ]

    twitterTags.forEach(({ name, content }) => {
      if (!content) return
      let metaTag = document.querySelector(`meta[name="${name}"]`)
      if (!metaTag) {
        metaTag = document.createElement('meta')
        metaTag.setAttribute('name', name)
        document.head.appendChild(metaTag)
      }
      metaTag.setAttribute('content', content)
    })
  }, [title, description])

  return null
}
